import { useForm } from "react-hook-form"
import { useColumns } from "../utils/columns";
import { Suspense, useMemo, useState } from "react";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Tabla from "../../../../components/ui/materialui/tabla";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { FilterList } from "@mui/icons-material";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import YearSelect from "../../../../components/inputs/yup/materialui/yearSelect";
import { useInformesCMF } from "../hooks/useInformesCMF";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Filtros, TipoInformeCMF } from "../models/informeCMF";
import { descargarInformeCMF } from "../../../detalleMutuo/services/servicesReportes";
import { Iprops } from "../../../maestros/cobranzaJudicial/models/cobranzaJudicial";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";


interface IProps {
    tipo: TipoInformeCMF
    fecha: Date
}

const validationSchema = yup.object().shape({
    tipo: yup
        .mixed<TipoInformeCMF>()
        .oneOf(Object.values(TipoInformeCMF), "Tipo informe es requerido")
        .required("Tipo informe es requerido"),
    fecha: yup.date().required("La fecha es requerida"),
});

function InfomesCMF() {

    const fecha = useMemo(() => new Date(), []); 


    const {
        formState: { errors },
        control,
        handleSubmit,
        setValue,
    } = useForm<IProps>({
        mode: 'onBlur',
        resolver: yupResolver(validationSchema),
        defaultValues:
        {
            fecha: fecha
        }
    })


    const { dataInformes, getInformes } = useInformesCMF();

    const { COLUMNS } = useColumns();
    const columns = useMemo(() => COLUMNS, [dataInformes]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Reportes', url: `/reportes` },
        { label: 'Informes CMF', active: true },
    ]

    const onSubmit = async (data: IProps) => {
        await getInformes(data)

    };


  const handleClicEmitir = async (data: IProps) => {
  const filtros: Filtros = {
    tipo: data.tipo,
    fecha: data.fecha 
  };

  await descargarInformeCMF(filtros);
};



    const tipoOptions = [
        { label: "Mutuos hipotecarios otorgados", value: TipoInformeCMF.MutuosHipotecariosOtorgados },
        { label: "Cambio de administracion y estado", value: TipoInformeCMF.CambioAdministracionYEstado },
        { label: "Mutuos hipotecarios endosados", value: TipoInformeCMF.MutuosHipotecariosEndosados },
        { label: "Tasaciones y retasaciones", value: TipoInformeCMF.TasacionesYRetasaciones },
        { label: "Tablas de desarrollo", value: TipoInformeCMF.TablasDeDesarrollo },
        { label: "Prepagos", value: TipoInformeCMF.Prepagos },
        { label: "Mutuos en administración", value: TipoInformeCMF.MutuosEnAdministracion },
        { label: "Inscripción en el conservador de bienes raices", value: TipoInformeCMF.InscripcionConservadorBienesRaices },

    ]

    
    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={3}>
                                            <InputFecha
                                                name="fecha"
                                                control={control}
                                                label="Fecha"
                                                onlyMonthPicker
                                                error={errors.fecha}
                                                fecha={fecha}

                                            />
                                        </Grid2>
                                        <Grid2 size={3}>
                                            <InputSelect
                                                name="tipo"
                                                control={control}
                                                label="Tipo informe"
                                                options={tipoOptions}
                                                error={errors.tipo}

                                            />
                                        </Grid2>


                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                data={dataInformes}
                                titulo={
                                    <TableHeader
                                        title=""
                                        button={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Reportes_CMF]}>
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                onClick={handleSubmit(handleClicEmitir)}
                                                 startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Generar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel([], columns, "Movimientos contables")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>


            </Suspense>

        </>
    );
}
export default InfomesCMF